/**
 * This file contains logic to show and hide filter modal on smaller screen sizes.
 */
( function() {
	const initFilterModal = () => {

	// Cache DOM references
	const body = document.body;

	const modalToggles = document.querySelectorAll( '.filter-modal-toggle' );

	// Bail out early if there are no modal toggles found
	if ( modalToggles.length === 0 ) return;

	function initModal( modalToggle ) {

		// Find parent listing and filter sidebar
		const listing = modalToggle.closest( '.listing-container' );
		const sidebar = listing.querySelector( '.filter-list-container' );

		const closeModal = () => {

			// Toggle modal readiness
			sidebar.classList.toggle( 'modal-ready' );

			// Move the count-results before the sort-results in the listing container
			sidebar.insertBefore(
				listing.querySelector( '.count-results' ),
				listing.querySelector( '.sort-results' )
			);

			// Remove modal-open class from body
			body.classList.remove( 'modal-open' );
		}

		// Add click event listener to the modal toggle
		modalToggle.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			sidebar.classList.add( 'modal-ready' );

			const $searchPhrase = sidebar.querySelector( '.facet-pane--search_phrase' );

			// Move .count-results to the specific facet pane
			if ( $searchPhrase ) {
				$searchPhrase.appendChild( listing.querySelector( '.count-results' ) );
			}
		} );

		// Listen for Escape key press to close the modal.
		sidebar.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Escape' && sidebar.classList.contains( 'modal-ready' ) ) {
				closeModal();
			}
		} );

		// Add click event listener to close modal when the .close button is clicked
		sidebar.querySelector( '.close' ).addEventListener( 'click', closeModal );

		// Add click event listener to close modal when the .filter-modal-result button is clicked
		sidebar.querySelector( '.filter-footer .filter-modal-result' ).addEventListener( 'click', closeModal );
	}

	//initialize every modalToggle -- there will most likely be only one but we do support multiple
	modalToggles.forEach( modalToggle => initModal( modalToggle ) );
	};

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initFilterModal, { once: true } );
	} else {
		initFilterModal();
	}
} )();
